import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import { signup } from 'identity/userManager'
import { decorateUrl } from 'components/common/UTMscript'
import UI from './UI'
import { AlgeriaId } from 'constants/'

const mapStateToProps = ({ user, referential }) => ({
  isElligableForTrial: user.isElligableForTrial,
  isFrance: referential.IsFrance,
  isAlgeria: referential?.CountryDetails?.Id === AlgeriaId
})

const mapDispatchToProps = (dispatch) => ({
  signup,
  goToUrl: link => dispatch(push(decorateUrl(link)))
})

export default connect(mapStateToProps, mapDispatchToProps)(UI)
